// extracted by mini-css-extract-plugin
module.exports = {"skip-link":"styles_skip-link__4nBk3"};